/** Layout constants for the ownership section's switcher popovers. */

/**
 * Popover width. The org switcher's own popover is 260px; this is widened so a user row has room for
 * an email beside the name, and capped so it can't overflow a narrow viewport.
 */
export const SWITCHER_POPOVER_WIDTH_CLASS = "w-80 max-w-[calc(100vw-2rem)]";

/**
 * Height of a switcher popover's scrolling list, shared by the search and linked-org steps. Both a min
 * and a max (not just a max): the search step's list is empty/loading for a beat before results arrive,
 * and if that state is noticeably shorter than the loaded list, the height change mid-open trips Radix's
 * collision detection into flipping the popover from below the trigger to above it, or back: the
 * visible "opens down then jumps up" glitch. Keeping the box's footprint constant regardless of loading
 * state avoids giving Radix a reason to recompute the side after the initial placement.
 */
export const SWITCHER_LIST_HEIGHT_CLASS = "min-h-[220px] max-h-[220px]";
